class MonextContractResource {

    public static $inject: string[] = [
        "$resource",
        "configService"
    ];

    constructor(
        $resource,
        configService
    ) {
        return headers => {
            return $resource( configService.paymentApi.url + "/v1/organizations/:id/contracts/monext", {id: "@id"}, {
                create: {
                    method: "POST",
                    headers: headers || {}
                },
                update:{
                    method: "PATCH",
                    headers: headers || {}
                }
            });
        };
    }
}

angular
    .module("thor.core.monext-contract.resource", [])
    .factory("monextContractResource", MonextContractResource);
